module.exports = __webpack_public_path__ + "img/comingsoon.528f13ff.png";